import { NEW_LINES } from "./constants";

const getEnergyLabelLink = (
  { key_prod: productId, pageLine, energyLabelCav },
  LANG,
  config,
  index
) => {
  const isNewEnergyLabelEu = pageLine?.docConfiguration.includes("new energy label (en)");
  const isNewEnergyLabelUk = pageLine?.docConfiguration.includes("new energy label (uk)");
  const isEnergyLabel = pageLine?.docConfiguration.includes("energy label");
  const DOC_BASE_URL = `https://docgenerator.candy.it/docgenerator`;
  const energyLabelUrl = `${DOC_BASE_URL}/${
    isOldEnergyLabel(config.isElMarket, pageLine?.lineId) || isEnergyLabel
      ? `energylabel?lan=${LANG}&`
      : "newenergylabel?"
  }`;

  if (isNewEnergyLabelUk && isNewEnergyLabelUk.value !== "[]") {
    return `${energyLabelUrl}mkt=UK&sku=${productId}`;
  } else if (
    (isNewEnergyLabelEu && isNewEnergyLabelEu.value !== "[]") ||
    (isEnergyLabel && isEnergyLabel.value !== "[]")
  ) {
    if (energyLabelCav > 0) {
      return `${energyLabelUrl}mkt=EU&sku=${productId}&cav=${index + 1}`;
    } else {
      return `${energyLabelUrl}mkt=EU&sku=${productId}`;
    }
  } else {
    return "";
  }
};

export const isOldEnergyLabel = (isElMarket, lineId) => {
  return isElMarket?.[0] === "yes" || !NEW_LINES.includes(`${lineId}`);
};

export default getEnergyLabelLink;
